/** THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
export const LIGHT_THEME_COLORS = {
  'color-neutral-content-strong': '#27272B',
  'color-neutral-content-medium': '#4F4F56',
  'color-neutral-border-strong': '#AAAAB6',
  'color-neutral-border-medium': '#E2E2E9',
  'color-neutral-background-strong': '#F6F6F9',
  'color-neutral-background-medium': '#FFFFFF',
  'color-neutral-background-soft': '#F0F0F4',
  'color-brand-content': '#0000FF',
  'color-brand-decoration': '#95A6FF',
  'color-brand-background': '#EDF0FF',
  'color-status-content-success': '#007F00',
  'color-status-background-success': '#E2F6E2',
  'color-status-content-warning': '#C24100',
  'color-status-background-warning': '#FFEEDD',
  'color-status-content-error': '#D91414',
  'color-status-background-error': '#FFEDEB',
  'color-status-content-information': '#006BD4',
  'color-status-background-information': '#E5F2FF',
  'color-status-content-all-accent': '#FFFFFF',
  'color-status-background-success-accent': '#008800',
  'color-status-background-warning-accent': '#CE4600',
  'color-status-background-error-accent': '#E71616',
  'color-status-background-information-accent': '#0072E2',
  'color-additional-content-color1': '#007A7A',
  'color-additional-background-color1': '#DAF7F5',
  'color-additional-content-color2': '#7F3FFF',
  'color-additional-background-color2': '#F4EEFF',
  'color-additional-content-color3': '#D01672',
  'color-additional-background-color3': '#FFECF5',
  'color-additional-content-color4': '#A05D00',
  'color-additional-background-color4': '#FAF1D5',
  'color-additional-content-all-accent': '#FFFFFF',
  'color-additional-background-color1-accent': '#008282',
  'color-additional-background-color2-accent': '#874BFF',
  'color-additional-background-color3-accent': '#DE187A',
  'color-additional-background-color4-accent': '#AA6400',
  'color-global-content-link': '#0000FF',
  'color-global-border-focus': '#4756FF',
  'color-global-all-disabled-strong': '#AAAAB6',
  'color-global-all-disabled-soft': '#E2E2E9',
  'color-global-overlay-medium': '#17171A52',
  'color-action-primary-content-default': '#FFFFFF',
  'color-action-primary-content-interacting': '#FFFFFF',
  'color-action-primary-border-default': '#90909A00',
  'color-action-primary-border-interacting': '#90909A00',
  'color-action-primary-background-default': '#0000FF',
  'color-action-primary-background-interacting': '#3547FF',
  'color-action-secondary-content-default': '#0000FF',
  'color-action-secondary-content-interacting': '#3547FF',
  'color-action-secondary-border-default': '#90909A00',
  'color-action-secondary-border-interacting': '#90909A00',
  'color-action-secondary-background-default': '#90909A1F',
  'color-action-secondary-background-interacting': '#DBE1FF',
  'color-action-tertiary-content-default': '#0000FF',
  'color-action-tertiary-content-interacting': '#3547FF',
  'color-action-tertiary-border-default': '#90909A00',
  'color-action-tertiary-border-interacting': '#90909A00',
  'color-action-tertiary-background-default': '#90909A00',
  'color-action-tertiary-background-interacting': '#90909A1F',
  'color-selection-primary-content-default': '#4F4F56',
  'color-selection-primary-content-interacting': '#3547FF',
  'color-selection-primary-content-selected': '#FFFFFF',
  'color-selection-primary-border-default': '#737380',
  'color-selection-primary-border-interacting': '#3547FF',
  'color-selection-primary-border-selected': '#7088FF00',
  'color-selection-primary-background-default': '#FFFFFF',
  'color-selection-primary-background-interacting': '#DBE1FF',
  'color-selection-primary-background-selected': '#5461FF',
  'color-selection-secondary-content-default': '#62626F',
  'color-selection-secondary-content-interacting': '#3D3D43',
  'color-selection-secondary-content-selected': '#0000FF',
  'color-selection-secondary-border-default': '#90909A00',
  'color-selection-secondary-border-interacting': '#90909A00',
  'color-selection-secondary-border-selected': '#90909A00',
  'color-selection-secondary-background-default': '#90909A00',
  'color-selection-secondary-background-interacting': '#90909A1F',
  'color-selection-secondary-background-selected': '#DBE1FF',
  'color-edition-content-default': '#27272B',
  'color-edition-content-interacting': '#0000FF',
  'color-edition-border-default': '#90909A',
  'color-edition-border-interacting': '#5461FF',
  'color-edition-background-default': '#FFFFFF',
  'color-edition-background-interacting': '#FFFFFF'
}
export const DARK_THEME_COLORS = {
  'color-neutral-content-strong': '#27272B',
  'color-neutral-content-medium': '#4F4F56',
  'color-neutral-border-strong': '#AAAAB6',
  'color-neutral-border-medium': '#E2E2E9',
  'color-neutral-background-strong': '#F6F6F9',
  'color-neutral-background-medium': '#FFFFFF',
  'color-neutral-background-soft': '#F0F0F4',
  'color-brand-content': '#0000FF',
  'color-brand-decoration': '#95A6FF',
  'color-brand-background': '#EDF0FF',
  'color-status-content-success': '#007F00',
  'color-status-background-success': '#E2F6E2',
  'color-status-content-warning': '#C24100',
  'color-status-background-warning': '#FFEEDD',
  'color-status-content-error': '#D91414',
  'color-status-background-error': '#FFEDEB',
  'color-status-content-information': '#006BD4',
  'color-status-background-information': '#E5F2FF',
  'color-status-content-all-accent': '#FFFFFF',
  'color-status-background-success-accent': '#008800',
  'color-status-background-warning-accent': '#CE4600',
  'color-status-background-error-accent': '#E71616',
  'color-status-background-information-accent': '#0072E2',
  'color-additional-content-color1': '#007A7A',
  'color-additional-background-color1': '#DAF7F5',
  'color-additional-content-color2': '#7F3FFF',
  'color-additional-background-color2': '#F4EEFF',
  'color-additional-content-color3': '#D01672',
  'color-additional-background-color3': '#FFECF5',
  'color-additional-content-color4': '#A05D00',
  'color-additional-background-color4': '#FAF1D5',
  'color-additional-content-all-accent': '#FFFFFF',
  'color-additional-background-color1-accent': '#008282',
  'color-additional-background-color2-accent': '#874BFF',
  'color-additional-background-color3-accent': '#DE187A',
  'color-additional-background-color4-accent': '#AA6400',
  'color-global-content-link': '#0000FF',
  'color-global-border-focus': '#4756FF',
  'color-global-all-disabled-strong': '#AAAAB6',
  'color-global-all-disabled-soft': '#E2E2E9',
  'color-global-overlay-medium': '#17171A52',
  'color-action-primary-content-default': '#FFFFFF',
  'color-action-primary-content-interacting': '#FFFFFF',
  'color-action-primary-border-default': '#90909A00',
  'color-action-primary-border-interacting': '#90909A00',
  'color-action-primary-background-default': '#0000FF',
  'color-action-primary-background-interacting': '#3547FF',
  'color-action-secondary-content-default': '#0000FF',
  'color-action-secondary-content-interacting': '#3547FF',
  'color-action-secondary-border-default': '#90909A00',
  'color-action-secondary-border-interacting': '#90909A00',
  'color-action-secondary-background-default': '#90909A1F',
  'color-action-secondary-background-interacting': '#DBE1FF',
  'color-action-tertiary-content-default': '#0000FF',
  'color-action-tertiary-content-interacting': '#3547FF',
  'color-action-tertiary-border-default': '#90909A00',
  'color-action-tertiary-border-interacting': '#90909A00',
  'color-action-tertiary-background-default': '#90909A00',
  'color-action-tertiary-background-interacting': '#90909A1F',
  'color-selection-primary-content-default': '#4F4F56',
  'color-selection-primary-content-interacting': '#3547FF',
  'color-selection-primary-content-selected': '#FFFFFF',
  'color-selection-primary-border-default': '#737380',
  'color-selection-primary-border-interacting': '#3547FF',
  'color-selection-primary-border-selected': '#7088FF00',
  'color-selection-primary-background-default': '#FFFFFF',
  'color-selection-primary-background-interacting': '#DBE1FF',
  'color-selection-primary-background-selected': '#5461FF',
  'color-selection-secondary-content-default': '#62626F',
  'color-selection-secondary-content-interacting': '#3D3D43',
  'color-selection-secondary-content-selected': '#0000FF',
  'color-selection-secondary-border-default': '#90909A00',
  'color-selection-secondary-border-interacting': '#90909A00',
  'color-selection-secondary-border-selected': '#90909A00',
  'color-selection-secondary-background-default': '#90909A00',
  'color-selection-secondary-background-interacting': '#90909A1F',
  'color-selection-secondary-background-selected': '#DBE1FF',
  'color-edition-content-default': '#27272B',
  'color-edition-content-interacting': '#0000FF',
  'color-edition-border-default': '#90909A',
  'color-edition-border-interacting': '#5461FF',
  'color-edition-background-default': '#FFFFFF',
  'color-edition-background-interacting': '#FFFFFF'
}
